import { t } from "i18next";

export const SettingMenu = [
    {
        type: 'group',
        title: 'Site Settings',
        icon: 'calendar-outline',
        class: '',
        expanded: true,
        hidden: false,
        children: [
            {
                type: 'item',
                title: 'General Configuration',
                permission: 'core:setting:generalConfiguration',
                link: { to: '/setting/general-setting/general-configuration', exactMatch: true, externalUrl: false, openInNewTab: false },
                icon: '',
                class: '',
                badge: '',
                badgeClass: '',
                hidden: false,
            },
            {
                type: 'item',
                title: 'Notifications',
                permission: 'core:setting:notification',
                link: { to: '/setting/general-setting/notification', exactMatch: true, externalUrl: false, openInNewTab: false },
                icon: '',
                class: '',
                badge: '',
                badgeClass: '',
                hidden: false,
            },
        ],
    },
    {
        type: "group",
        title: t("Eticket Setup"),
        icon: "calendar-outline",
        class: 'eticket:settingMenu:adminPanel:ticketTimeoutAndVat',
        expanded: true,
        hidden: false,
        children: [
          {
            type: "item",
            title: t("Ticket Timeout & Vat"),
            permission: "",
            link: { to: "/setting/ticket-timeout", exactMatch: true, externalUrl: false, openInNewTab: false },
            icon: "",
            class: "",
            badge: "",
            badgeClass: "",
            hidden: false,
          },
        ],
      },
];
